/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as Actions from "actions/admin/admin.products";
import * as ActionTypes from "constants/ActionTypes";
import {
    TextField, InputAdornment, IconButton, Container, Typography, Chip, Box, Grid, MenuItem, Checkbox, Button,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import AdminSellerProduct from "components/elements/admin/products/AdminSellerProduct";
import AdminSellerProductEditor from "components/elements/admin/products/AdminSellerProductEditor";
import AdminSellerProductEditorSetting from "components/elements/admin/products/AdminSellerProductEditorSetting";
import MockProductBoxList from "components/elements/main/MockProductBoxList";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { H6 } from "components/CustomTypography";

import AdminSellerProductStatusSelector from "components/elements/admin/products/AdminSellerProductStatusSelector";
import CustomFlexBox from "components/CustomFlexBox";
import DatePicker from "react-datepicker";
import {getAdminProductSortList, getAdminProductStatusList} from "helpers/utils";
import ButtonComponent from "components/Button";
import SelectFieldComponent from "components/SelectField";
import {adminUpdateProductInfo} from "actions/admin/admin.products";
import {Notification} from "../../../Atoms";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const AdminProductSearch = (props) => {
  const [state, setState] = useState({
    limit: 20,
    hasMoreItems: true,
    breakPoint: "lg",
    bShowSearchModal: false,
    searchvalue: "Search products",
    isShop: false,
  });

  const [productState, setProductState] = useState("");
  const [productModeState, setProductModeState] = useState("PREVIEW");
    const [optionValues, setOptionValues] = useState([]);
    const [optionValuesCategory, setOptionValuesCategory] = useState([]);

    const [categoryState, setCategoryState] = useState("");
    const [filterState, setFilterState] = useState([]);
    const [sortState, setSortState] = useState("");
    const [startdateState, setStartdateState] = useState(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));
    const [cityState, setCityState] = useState("");
    const [offsetState, setOffsetState] = useState(0);
    
    // Selection state
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [bulkCategoryAutocompleteKey, setBulkCategoryAutocompleteKey] = useState(0);

    const {
    serviceError, reqStatus, isLoadingProducts, isLoadingCategorySearch,
    adminResetSearchProducts, adminResetSearchKeywords,
    adminSearchProducts, adminSearchProductKeywords,
        adminGetProductAndShopsInfo, adminUpdateStatusPrivateProduct, adminUpdateProductPriority,
      adminSendMessage, adminSearchCommonCategory, adminUpdateProductCategory, adminUpdateProductInfo, adminUpdateProductVideo,
    products, productshopsdetail, searchkeywords, searchcategorykeywords,
        adminResetProductDetail, adminResetCategorySearch, getCities, cities,
        adminGetCommonProductCategories, commonCategoryList,
      currency, match, history, symbol = "$",
    isLoadingShop, shopId, isShop, limit,
        userDetails
  } = props;

  const { keywords } = searchkeywords;
  const { keywordscategory } = searchcategorykeywords;

  const { productdetail, productshops } = productshopsdetail;

  const {
    resetvalue,
  } = state;

  const { query } = match.params;

  useEffect(() => {
    if (query) {
      adminResetSearchProducts();
      adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offsetState);
    } else {
      adminSearchProducts("", isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offsetState);
    }
    adminGetCommonProductCategories();
    getCities();
  }, []);

    const sendNotification = (type, { title, description = "" }) => {
        Notification[type]({
            message: title,
            description,
        });
    };

    useEffect(() => {
        if (serviceError && reqStatus) {
            const feedback = {
                title: serviceError,
                description: serviceError,
            };
            sendNotification("error", feedback);
        }
        switch (reqStatus) {
            case ActionTypes.ADMIN_ADD_PRIVATE_PRODUCT_QUICK_SUCCESS:
            case ActionTypes.ADMIN_UPDATE_PRODUCT_VIDEO_SUCCESS:
            case ActionTypes.ADMIN_UPDATE_PRODUCT_INFO_SUCCESS:
                if (query) {
                    adminResetSearchProducts();
                    adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offsetState);
                } else {
                    adminSearchProducts("", isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offsetState);
                }
                break;
            default:
                break;
        }
    }, [serviceError, reqStatus]);

  const runSearch = (keyword) => {
    adminResetSearchKeywords();
    setState({ searchquery: keyword });
    setState({ resetvalue: "" });

    if (isShop) {
      history.push(`/products/shop/${shopId}/psearch/${keyword}`);
    } else {
      history.push(`/products/psearch/${keyword}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      runSearch(e.target.value);
    }
  };

  const setKeyword = (option, type) => {
    if (type === "selectOption") {
      runSearch(option.target.innerText);
    }
  };

  const runKeywordSearch = (value) => {
    setState({ resetvalue: value });
    if ((value.length > 1)) {
      adminSearchProductKeywords(value, shopId, isShop);
    }
  };

  const selectKeywordSearch = (value) => {
    if (isShop) {
        history.push(`/products/shop/${shopId}/psearch/${value}`);
    } else {
        history.push(`/products/psearch/${value}`);
    }
  };

  const handleDelete = () => {
      if (isShop) {
          history.push(`/products/shop/${shopId}`);
      } else {
      history.push("/products");
        }
  };

  const updateProductStatus = (product) => {
      adminUpdateStatusPrivateProduct(product);
    setProductModeState("PREVIEW");
  };

    const updateProductPriority = (product) => {
        adminUpdateProductPriority(product);
        setProductModeState("PREVIEW");
    };


    const messageShop = (product, message) => {
        adminSendMessage({ pid: product.id, type: "product", msg: message });
        setProductModeState("PREVIEW");
    };

    const updateProductCategory = (prodId, categoryId) => {
        adminUpdateProductCategory({ pid: prodId, cid: categoryId });
        adminResetProductDetail();
        adminResetCategorySearch();
        setProductModeState("PREVIEW");
        adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offsetState);
    };

    const updateProductInfoAdmin = (prodinfo) => {
        adminUpdateProductInfo(prodinfo);
        setProductModeState("PREVIEW");
    };

    const adminUpdateProductVideoClicked = (id, formData) => {
        adminUpdateProductVideo(id, formData);
        setProductModeState("PREVIEW");
    };

    const runCategorySearch = (value) => {
        if ((value.length > 1)) {
            adminSearchCommonCategory(value);
        }
    };


  const handleProductEdit = (mode, product, reset) => () => {
    setProductModeState(mode);
    if (reset) {
      setProductState({
        selectedProduct: {
           _id: "", product_id: "", uid: "", slug: "",
            status: "", name: "", description: "", images: [],
            autocolor: "", color: "", is_color_locked: "",
            autocategory: "", is_category_locked: "", metadata: "", commoncategories : [], category: "",
            video: [],
        },
      });
    } else {
        adminGetProductAndShopsInfo(product.product_id);
      setProductState({
          selectedProduct: {
          _id: product.id, product_id: product.product_id, uid: product.uid, slug: product.slug,
              status: product.status, name: product.name, description: product.description,
              images: product.images, autocolor: product.autocolor, color: product.color, is_color_locked: product.is_color_locked,
              autocategory: product.autocategory, category: product.category, is_category_locked: product.is_category_locked,
              commoncategories: product.commoncategories,
              metadata: product.metadata, video: product.video,
          },
      });
    }
  };

  useEffect(() => {
    setOptionValues(keywords);
  }, [keywords]);

    useEffect(() => {
        setOptionValuesCategory(keywordscategory);
    }, [keywordscategory]);

    const setProductStatus = (status) => {
        setFilterState(status);
        adminSearchProducts(query, isShop, shopId, status, startdateState, sortState, categoryState, cityState, 0);
    };

    const CustomDatePicker = React.forwardRef(({ value, onClick }, ref) => (
        <ButtonComponent
            type="primary"
            variant="contained"
            name={value}
            size="small"
            onClick={onClick} ref={ref}>
            {value}
        </ButtonComponent>
    ));

    const handleProductAddDate = (update) => {
        setStartdateState(update.getTime());
        setOffsetState(0);
        adminSearchProducts(query, isShop, shopId, filterState, update.getTime(), sortState, categoryState, cityState, 0);
    };

    const handleSortProducts = (event) => {
        setSortState(event.target.value);
        setOffsetState(0);
        adminSearchProducts(query, isShop, shopId, filterState, startdateState, event.target.value, categoryState, cityState, 0);
    };

    const handleCategoryProducts = (event) => {
        setCategoryState(event.target.value);
        setOffsetState(0);
        adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, event.target.value, cityState, 0);
    };

    const handleFilterProducts = (event, newValue) => {
        setFilterState(newValue);
        setOffsetState(0);
        adminSearchProducts(query, isShop, shopId, newValue, startdateState, sortState, categoryState, cityState, 0);
    };

    const handleCityProducts = (event) => {
        setCityState(event.target.value);
        setOffsetState(0);
        adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, categoryState, event.target.value, 0);
    };

    const handleRestAll = (event) => {
        setFilterState([]);
        setStartdateState(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));
        setSortState("newest");
        setCategoryState("");
        setCityState("");
        setOffsetState(0);
        adminSearchProducts(query, isShop, shopId, [], new Date(new Date().getTime() + 24 * 60 * 60 * 1000), "newest", "", "", 0);
    };

    const handleReload = (event) => {
        adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offsetState);
     };

    const handlePrevOffset = () => {
        const offset = offsetState > 1 ? offsetState - 1 : 0;
        setOffsetState(offset);
        adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offset);
    }

    const handleNextOffset = () => {
        const offset = offsetState + 1;
        setOffsetState(offset);
        adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offset);
    }

    // Selection handlers
    const handleSelectAll = (event) => {
        const checked = event.target.checked;
        setSelectAll(checked);
        if (checked) {
            const allProductIds = products.map(product => product.product_id);
            setSelectedProducts(allProductIds);
        } else {
            setSelectedProducts([]);
        }
    };

    const handleSelectProduct = (productId) => (event) => {
        const checked = event.target.checked;
        if (checked) {
            setSelectedProducts([...selectedProducts, productId]);
        } else {
            setSelectedProducts(selectedProducts.filter(product_id => product_id !== productId));
            setSelectAll(false);
        }
    };

    // Bulk actions
    const handleBulkApprove = () => {
        if (selectedProducts.length === 0) {
            sendNotification("warning", { 
                title: "No products selected", 
                description: "Please select at least one product to approve" 
            });
            return;
        }

        // Approve each selected product
        selectedProducts.forEach(productId => {
            const product = products.find(p => p.product_id === productId);
            if (product && !product.is_verified) {
                adminUpdateStatusPrivateProduct({
                    pid: product.product_id,
                    is_verified: true
                });
            }
        });

        sendNotification("success", { 
            title: "Products approved", 
            description: `${selectedProducts.length} product(s) have been approved` 
        });
        
        // Clear selection and refresh
        setSelectedProducts([]);
        setSelectAll(false);
        
        // Refresh the product list after a short delay
        setTimeout(() => {
            adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offsetState);
        }, 1000);
    };

    const handleBulkDelete = () => {
        if (selectedProducts.length === 0) {
            sendNotification("warning", { 
                title: "No products selected", 
                description: "Please select at least one product to delete" 
            });
            return;
        }

        if (!window.confirm(`Are you sure you want to delete ${selectedProducts.length} product(s)? This action cannot be undone.`)) {
            return;
        }

        // Delete each selected product by setting status to deleted
        selectedProducts.forEach(productId => {
            const product = products.find(p => p.product_id === productId);
            if (product) {
                adminUpdateStatusPrivateProduct({
                    pid: product.product_id,
                    is_deleted: true
                });
            }
        });

        sendNotification("success", { 
            title: "Products deleted", 
            description: `${selectedProducts.length} product(s) have been deleted` 
        });
        
        // Clear selection and refresh
        setSelectedProducts([]);
        setSelectAll(false);
        
        // Refresh the product list after a short delay
        setTimeout(() => {
            adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offsetState);
        }, 1000);
    };

    const handleBulkSetHighPriority = () => {
        if (selectedProducts.length === 0) {
            sendNotification("warning", { 
                title: "No products selected", 
                description: "Please select at least one product to set as high priority" 
            });
            return;
        }

        // Set each selected product as high priority (is_popular = true)
        selectedProducts.forEach(productId => {
            const product = products.find(p => p.product_id === productId);
            if (product) {
                adminUpdateProductPriority({
                    pid: product.product_id,
                    is_popular: true
                });
            }
        });

        sendNotification("success", { 
            title: "High priority set", 
            description: `${selectedProducts.length} product(s) have been set as high priority` 
        });
        
        // Clear selection and refresh
        setSelectedProducts([]);
        setSelectAll(false);
        
        // Refresh the product list after a short delay
        setTimeout(() => {
            adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offsetState);
        }, 1000);
    };

    const handleBulkCategoryKeyPress = (e) => {
        if (e.key === "Enter") {
            runCategorySearch(e.target.value);
        }
    };

    const applyBulkCommonCategory = (categoryId) => {
        if (selectedProducts.length === 0) {
            sendNotification("warning", {
                title: "No products selected",
                description: "Select one or more products, then choose a category from search results.",
            });
            return;
        }
        selectedProducts.forEach((productId) => {
            adminUpdateProductCategory({ pid: productId, cid: categoryId });
        });
        adminResetCategorySearch();
        setBulkCategoryAutocompleteKey((k) => k + 1);
        sendNotification("success", {
            title: "Category update queued",
            description: `${selectedProducts.length} product(s) will be updated to the selected common category.`,
        });
        setSelectedProducts([]);
        setSelectAll(false);
        setTimeout(() => {
            adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offsetState);
        }, 1000);
    };

    const handleBulkCategorySelect = (event, newValue) => {
        if (newValue == null || typeof newValue !== "object") {
            return;
        }
        applyBulkCommonCategory(newValue.value);
    };

    const handleBulkClearCategory = () => {
        if (selectedProducts.length === 0) {
            sendNotification("warning", {
                title: "No products selected",
                description: "Please select at least one product to clear its common category.",
            });
            return;
        }
        if (!window.confirm(`Clear common category on ${selectedProducts.length} product(s)?`)) {
            return;
        }
        selectedProducts.forEach((productId) => {
            adminUpdateProductCategory({ pid: productId, cid: "" });
        });
        adminResetCategorySearch();
        setBulkCategoryAutocompleteKey((k) => k + 1);
        sendNotification("success", {
            title: "Category clear queued",
            description: `${selectedProducts.length} product(s) will have their common category cleared.`,
        });
        setSelectedProducts([]);
        setSelectAll(false);
        setTimeout(() => {
            adminSearchProducts(query, isShop, shopId, filterState, startdateState, sortState, categoryState, cityState, offsetState);
        }, 1000);
    };

    // Clear selection when products change (e.g., after filter/search)
    useEffect(() => {
        setSelectedProducts([]);
        setSelectAll(false);
    }, [offsetState, filterState, categoryState, cityState, sortState]);

  const MobileViewOnClick = () => {
    if (window.innerWidth <= 500 && (match.path !== "/products/psearch" || match.path !== "/products/shop/:shopId/psearch")) {
      history.push(isShop ? `/products/shop/${shopId}/psearch` : "/products/psearch");
    }
  };

  let isModalSearch = false;

    const productsort = getAdminProductSortList();

    const sortOptions = productsort.map((item) => {
        const { value, label } = item;
        return (
            <MenuItem value={value}>{label}</MenuItem>
        );
    });

    const { categories } = commonCategoryList;

    const categoryFilterOptions = categories.map((item) => {
        const { id, name } = item;
        return (
            <MenuItem value={id}>{name}</MenuItem>
        );
    });


    const statusList = getAdminProductStatusList();

    const inputProductFilterOptions = statusList.map((item) => {
        const { value, label } = item;
        return (
            <MenuItem value={value}>{label}</MenuItem>
        );
    });

    const citiesFilterOptions = cities.map((item) => {
        const { id, name } = item;
        return (
            <MenuItem value={id}>{name}</MenuItem>
        );
    });

    const renderNoResults = () => (
      <Container>
        <Box>
          <Typography className="m-2" align="center">
            <H6>
              No Product found
            </H6>
          </Typography>
        </Box>
      </Container>
  );

  const renderResults = () => (
      <div>
          {/* Bulk actions toolbar */}
          <Box sx={{ 
              display: 'flex', 
              flexWrap: 'wrap',
              gap: 1,
              alignItems: 'center', 
              mb: 2, 
              p: 2, 
              backgroundColor: '#f5f5f5', 
              borderRadius: 1 
          }}>
              <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAll}
                  indeterminate={selectedProducts.length > 0 && selectedProducts.length < products.length}
              />
              <Typography variant="body1" sx={{ ml: 1, mr: 3 }}>
                  {selectedProducts.length > 0 
                      ? `${selectedProducts.length} selected` 
                      : 'Select All'}
              </Typography>
              
              {selectedProducts.length > 0 && (
                  <>
                      <Button 
                          variant="contained" 
                          color="success" 
                          onClick={handleBulkApprove}
                          sx={{ mr: 2 }}
                      >
                          Approve Selected ({selectedProducts.length})
                      </Button>
                      <Button 
                          variant="contained" 
                          color="warning" 
                          onClick={handleBulkSetHighPriority}
                          sx={{ mr: 2 }}
                      >
                          Set High Priority ({selectedProducts.length})
                      </Button>
                      <Button 
                          variant="contained" 
                          color="error" 
                          onClick={handleBulkDelete}
                          sx={{ mr: 2 }}
                      >
                          Delete Selected ({selectedProducts.length})
                      </Button>
                      <Box sx={{ minWidth: 260, maxWidth: 420, flex: "1 1 260px", mr: 2 }}>
                          <Autocomplete
                              key={bulkCategoryAutocompleteKey}
                              id="admin-bulk-product-category"
                              loading={isLoadingCategorySearch}
                              disableClearable
                              freeSolo
                              onKeyPress={handleBulkCategoryKeyPress}
                              onChange={handleBulkCategorySelect}
                              onSelect={(input) => runCategorySearch(input.target.value)}
                              options={optionValuesCategory}
                              renderOption={(optionProps, option) => (
                                  <Box component="li" {...optionProps} key={option.value}>
                                      {option.parent} {option.label}
                                  </Box>
                              )}
                              renderInput={(params) => (
                                  <TextField
                                      {...params}
                                      InputProps={{
                                          ...params.InputProps,
                                          endAdornment: (
                                              <InputAdornment position="end">
                                                  <IconButton size="large" tabIndex={-1}>
                                                      <SearchIcon />
                                                  </IconButton>
                                              </InputAdornment>
                                          ),
                                      }}
                                      type="search"
                                      size="small"
                                      label="Set common category (search)"
                                      placeholder="Type to search, pick a row"
                                      margin="dense"
                                  />
                              )}
                          />
                      </Box>
                      <Button
                          variant="outlined"
                          color="inherit"
                          onClick={handleBulkClearCategory}
                      >
                          Clear category
                      </Button>
                  </>
              )}
          </Box>

          {/* Products grid */}
          <Grid item container md={9} xs={12} spacing={2}>
        { products.map((product, index) => (
            <Grid item xs={6} sm={4} key={index}>
              <AdminSellerProduct
                  product={product}
                  userDetails={userDetails}
                  currency={currency}
                  key={`${index + 1}`}
                  editProductStatus={handleProductEdit("EDIT", product, false)}
                  editProductSetting={handleProductEdit("EDIT_SET", product, false)}
                  isSelected={selectedProducts.includes(product.product_id)}
                  onSelectProduct={handleSelectProduct(product.product_id)}
              />
            </Grid>
        ))}
          </Grid>
      </div>
  );

  const renderSearchHelp = () => (
      <Container>
          <Box>
              {
                  window.innerWidth <= 500
                  && (match.path === "/products/psearch" || match.path === "/products/shop/:shopId/psearch")
                  && optionValues.map((element) => (
                      <Container>
                          <Typography onClick={() => selectKeywordSearch(element.label)}>
                              <IconButton disabled size="large">
                                  <SearchIcon />
                              </IconButton>
                              {element.label}
                          </Typography>
                      </Container>
                  ))
              }
          </Box>
      </Container>
  );

  const renderSearchModule = () => (
    <>

      <Container onClick={MobileViewOnClick}>
          <Box>
        {
            window.innerWidth <= 500
            && (match.path === "/products/psearch" || match.path === "/products/shop/:shopId/psearch") ? isModalSearch = true : isModalSearch = false
          }
        <Autocomplete
          id="autocomplete1"
          onClose={setKeyword}
          disableClearable
          freeSolo
          inputValue={resetvalue}
          onOpen={() => setState({ selected: false })}
          value={resetvalue}
          onKeyPress={handleKeyPress}
          onSelect={(input) => runKeywordSearch(input.target.value)}
          options={window.innerWidth <= 500 ? [] : optionValues.map((element) => element.label)}
          renderInput={(params) => (
            <TextField
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="large" onClick={() => props.history.push("/")}>
                      <ArrowBackIosIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              {...params}
              type="search"
              size="large"
              autoFocus={isModalSearch}
              label={`Search ${process.env.REACT_APP_PRODUCT_TITLE}`}
              placeholder={`Search ${process.env.REACT_APP_PRODUCT_TITLE}`}
              margin="normal"
            />
          )}
        />
        </Box>
      </Container>

        {
            renderSearchHelp()
        }


      <Container>
        {query && (
        <Chip
          label={query}
          onDelete={handleDelete}
        />
        )}
      </Container>

      { match.path !== "/"
      && (
          match.path === "/products/psearch/:query" ||
          match.path === "/products/shop/:shopId" ||
          match.path === "/products/shop/:shopId/psearch/:query" ||
          match.path === "/shops/shop/:shopId" ||
          match.path === "/shops" ||
          match.path === "/saleslog" || /* displayed in sales log as well */
          match.path === "/products"
      ) && (
      <>

          <CustomFlexBox sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%'
          }}>
              <Box width="50%">Before:
                  <DatePicker
                      sx={{margin: "4px"}}
                      placeholderText="Select Date"
                      selected={startdateState}
                      maxDate={new Date(new Date().getTime() + 24 * 60 * 60 * 1000)}
                      onChange={handleProductAddDate}
                      dateFormat="MMMM d, yy"
                      customInput={<CustomDatePicker />}
                  />

              </Box>
              <Box width="50%" align="right">
                  <ButtonComponent
                      sx={{margin: "4px"}}
                      type="primary"
                      variant="contained"
                      name="Reset"
                      size="small"
                      onClick={handleRestAll}>
                  </ButtonComponent>
                  <ButtonComponent
                      sx={{margin: "4px"}}
                      type="primary"
                      variant="contained"
                      name="Reload"
                      size="small"
                      onClick={handleReload}>
                  </ButtonComponent>
              </Box>
          </CustomFlexBox>
          <CustomFlexBox sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%'
          }}>
              <Box width="25%">
              <SelectFieldComponent
                  sx={{margin: "4px"}}
                  required
                  options={sortOptions}
                  label="Sort"
                  value={sortState}
                  onChange={(event) => handleSortProducts(event)}
              />
              </Box>

              <Box width="25%">
              <SelectFieldComponent
                  sx={{margin: "4px"}}
                  required
                  options={categoryFilterOptions}
                  label="By Category"
                  value={categoryState}
                  onChange={(event) => handleCategoryProducts(event)}
              />
              </Box>

              <Box width="25%">
              <Autocomplete
                  multiple
                  sx={{margin: "4px", flex: 1}}
                  options={statusList}
                  getOptionLabel={(option) => option.label}
                  value={statusList.filter(item => filterState.includes(item.value))}
                  onChange={(event, newValue) => handleFilterProducts(event, newValue.map(item => item.value))}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Status Filters"
                      placeholder="Select filters"
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option.label}
                        {...getTagProps({ index })}
                        key={option.value}
                      />
                    ))
                  }
              />
              </Box>

              <Box width="25%">
              <SelectFieldComponent
                  sx={{margin: "4px"}}
                  required
                  options={citiesFilterOptions}
                  label="By City"
                  value={cityState}
                  onChange={(event) => handleCityProducts(event)}
              />
              </Box>
          </CustomFlexBox>


          {!(isLoadingProducts) && products.length > 0 && <CustomFlexBox m={2} sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
          }}>
              <Box width="60%" align="center">
              </Box>
              <Box width="20%" align="right">
                  {offsetState > 0 && <IconButton onClick={handlePrevOffset}>
                      <ArrowBackIosIcon fontSize="medium" color="primary"/>
                  </IconButton>
                  }
              </Box>
              <Box width="20%" align="right">
                  <IconButton onClick={handleNextOffset}>
                      <ArrowForwardIosIcon fontSize="medium" color="primary"/>
                  </IconButton>

              </Box>
          </CustomFlexBox>
          }

          {isLoadingProducts ? <MockProductBoxList />
            : products.length > 0
              ? renderResults()
              : renderNoResults()}
      </>
      )}
    </>
  );

  const renderProductEdit = (productMode) => {
    switch (productMode) {
      case "EDIT":
        return (
            <AdminSellerProductEditor
                setState={(value, field) => setProductState({
                  ...state,
                  selectedProduct: {
                    ...selectedProduct,
                    [field]: value,
                  },
                })}
                symbol={symbol}
                userDetails={userDetails}
                isLoading={isLoadingProducts}
                productdetail={productdetail}
                productshops={productshops}
                selectedProduct={selectedProduct}
                updateProductStatusClicked={updateProductStatus}
                adminUpdateProductVideoClicked={adminUpdateProductVideoClicked}
                messageShopClicked={messageShop}
                onCancel={() => setProductModeState("PREVIEW")}
            />
        );
      case "EDIT_SET":
      default:
        return (
            <AdminSellerProductEditorSetting
                setState={(value, field) => setProductState({
                  ...state,
                  selectedProduct: {
                    ...selectedProduct,
                    [field]: value,
                  },
                })}
                symbol={symbol}
                userDetails={userDetails}
                isLoading={isLoadingProducts}
                isLoadingCategorySearch={isLoadingCategorySearch}
                currency={currency}
                productdetail={productdetail}
                productshops={productshops}
                selectedProduct={selectedProduct}
                history={history}
                updateProductCategory={updateProductCategory}
                updateProductClicked={updateProductInfoAdmin}
                updateProductPriorityClicked={updateProductPriority}
                runCategorySearch={runCategorySearch}
                optionValuesCategory={optionValuesCategory}
                onCancel={() => setProductModeState("PREVIEW")}
            />
        );
    }
  };

  const { selectedProduct = {} } = productState;
  const { records } = products;

  return (
      <Container>
        {productModeState === "PREVIEW" ? (
            renderSearchModule()
        ) : (
            renderProductEdit(productModeState)
        )}
      </Container>
  );


};

AdminProductSearch.defaultProps = {
  currency: "",
  isLoadingCategorySearch: false,
};

AdminProductSearch.propTypes = {
  currency: PropTypes.string,
  isLoadingCategorySearch: PropTypes.bool,
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  products: PropTypes.arrayOf(PropTypes.any).isRequired,
  searchkeywords: PropTypes.objectOf(PropTypes.any).isRequired,
    commonCategoryList: PropTypes.objectOf(PropTypes.any).isRequired,
  adminSearchProducts: PropTypes.func.isRequired,
  adminSearchProductKeywords: PropTypes.func.isRequired,
  adminResetSearchKeywords: PropTypes.func.isRequired,
  adminResetSearchProducts: PropTypes.func.isRequired,
    adminGetProductAndShopsInfo: PropTypes.func.isRequired,
    adminUpdateStatusPrivateProduct: PropTypes.func.isRequired,
    adminUpdateProductCategory: PropTypes.func.isRequired,
    adminSendMessage: PropTypes.func.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const AdminProductSearchComponent = connect(
  ({ adminProducts, bootupInfo, adminShops }) => ({
    bootupInfo,
      cities: bootupInfo.cities,
      userDetails: bootupInfo.userDetails,
    currency: bootupInfo.symbol,
    reqStatus: adminProducts.reqStatus,
    isLoadingProducts: adminProducts.isLoading,
    isLoadingCategorySearch: adminProducts.isLoadingCommonCategorySearch,
    serviceError: adminProducts.serviceError,
    products: adminProducts.searchproducts,
    searchkeywords: adminProducts.searchkeywords,
      searchcategorykeywords: adminProducts.searchcategorykeywords,
      commonCategoryList: adminProducts.categoryList,
      productshopsdetail: adminProducts.productshopsdetail,
      shopDetail: adminShops.shopDetail,
    isLoadingShop: adminShops.isLoading,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(AdminProductSearch);

export { AdminProductSearchComponent as default };
